import React, {Component} from 'react';
import './StepCategories.css';
import ApiConnector from '../api/ApiConnector';
import GlobalStore from '../../store/GlobalStore';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import ReactQueryParams from 'react-query-params';
import TagManager from 'react-gtm-module';
import {config} from '../../config.js';

var parentThis;

class StepCategories extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            apiCategories: [],
            loader: true,
            parentCategoryId: undefined,
        };
    }

    componentDidMount() {
        let getApiCategory = ApiConnector.getCategory();
        getApiCategory
            .then(data => {
                if (data.ok !== undefined && !data.ok) {
                    throw Error('MAINTENANCE_MODE');
                }
                let resultApiCategories = data.map((item) => {
                    let rootCategoryClickProcessor = this.getSubCategories.bind(this, item);
                    return (
                        <div className="col-md-6 col-xs-12" key={item.Id}>
                            <div className="stepCategoriesItem" onClick={rootCategoryClickProcessor} key={item.Id}>
                                <div className="categoryItemName">{item.Name}</div>
                                <div className="categoryItemDisc">{item.Description}</div>
                                <span className="ripplesCircle"></span>
                            </div>
                        </div>
                    )
                });
                this.setState({apiCategories: resultApiCategories, loader: false});
            }).catch(error => {
            if (error.toString() === "Error: MAINTENANCE_MODE") {
                this.setState({loader: false});
                NotificationManager.error('Järjestelmässä on parhaillaan huoltokatko. Pahoittelemme häiriötä.', 'Yhteysongelma', 1000000, () => {
                    this.componentDidMount();
                });
            } else {
                this.setState({loader: false});
                NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                    this.componentDidMount();
                });
            }
        });
    }

    getSubCategories(parent, e) {
        this.setState({loader: true, parentCategoryId: parent.Id});
        let getApiSubCategory = ApiConnector.getSubCategory(parent.Id);
        getApiSubCategory
            .then(data => {
                let resultApiCategories = data.map((item) => {
                    let subCategoryClickProcessor = this.subCategoryOnClick.bind(this, item);
                    return (
                        <div className="col-md-6 col-xs-12" key={item.Id}>
                            <div className="stepCategoriesItem" onClick={subCategoryClickProcessor} key={item.Id}>
                                <div className="categoryItemName">{item.Name}</div>
                                <div className="categoryItemDisc">{item.Description}</div>
                                <span className="ripplesCircle"></span>
                            </div>
                        </div>
                    )
                });
                this.setState({apiCategories: resultApiCategories, loader: false});
            }).catch(() => {
            this.setState({loader: false});
            NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                this.getSubCategories(parent);
            });
        });
    }

    subCategoryOnClick(item, e) {
        this.setState({loader: true});
        // перехоплюємо клік по Nukutushoidon ensikäynti
        if (item.Id === "5d79010a-3afb-44e2-ae70-debaadd6905a") {
            alert("Дімончик, ходи сюди!");
        }
        // записуємо id підкатегорії у глобальний GlobalStore для подальшого використання
        GlobalStore.getInstance().data['categories'] = item.Id;
        GlobalStore.getInstance().data['categoryName'] = item.Name;


        const tagManagerArgsResultConfirmPage = {
            dataLayer: {
                event: 'select_content',
                content_type: 'category',
                content_id: GlobalStore.getInstance().data['categoryName']
            }
        };

        if (this.queryParams.env !== "test" && config.environment === "prod") {
            TagManager.dataLayer(tagManagerArgsResultConfirmPage);
        }

        this.nextStep();
    }

    render() {

        parentThis = this;

        return (
            <div className="stepCategories col-xs-12">
                {(this.state.loader === true) ? <div className="globalLoader">
                    <div className="globalSpinner"></div>
                </div> : ''}
                {this.state.apiCategories}

                <NotificationContainer/>

            </div>
        )
    };

    nextStep(e) {
        parentThis.props.nextStep();
    };
}

export default StepCategories;



// WEBPACK FOOTER //
// ./src/components/Step_1/StepCategories.jsx